import { HttpMethod, requestOptions } from "../../../utils/api/request-options";
import { handleResponse } from "../../../utils/api/response-handler";
import { AverageModule } from "../model/average-module";

export function getAverageRating(cohortId: number, moduleId?: string | undefined): Promise<AverageModule[]> {
    return fetch(`${process.env.REACT_APP_LMS_API_URL}/v3/statistics/average/rating/${cohortId}?moduleId=${moduleId ?? ''}`, requestOptions(HttpMethod.GET))
        .then(response => {
            return handleResponse<AverageModule[]>(response)
        });
}